import { takeEvery, put, call } from "redux-saga/effects"
import {
  FETCH_MESSAGES,
  SEND_MESSAGE,
  FETCH_NOTIFICATIONS,
  MARK_NOTIFICATION_READ,
  MARK_ALL_NOTIFICATIONS_READ,
} from "./actionTypes"
import {
  fetchMessagesSuccess,
  fetchMessagesFail,
  sendMessageSuccess,
  sendMessageFail,
  fetchNotificationsSuccess,
  fetchNotificationsFail,
} from "./actions"
import {
  getChatMessages,
  postChatMessage,
  getNotifications,
  markNotificationAsRead,
  markAllNotificationsAsRead,
} from "../../helpers/api_helper"

function* onFetchMessages({ payload: conversationId }) {
  try {
    const response = yield call(getChatMessages, conversationId)
    yield put(fetchMessagesSuccess(response))
  } catch (error) {
    yield put(fetchMessagesFail(error.message || "Failed to fetch messages"))
  }
}

function* onSendMessage({ payload: message }) {
  try {
    const response = yield call(postChatMessage, message)
    yield put(sendMessageSuccess(response))
  } catch (error) {
    yield put(sendMessageFail(error.message || "Failed to send message"))
  }
}

function* onFetchNotifications() {
  try {
    const response = yield call(getNotifications)
    yield put(fetchNotificationsSuccess(response))
  } catch (error) {
    yield put(fetchNotificationsFail(error.message || "Failed to fetch notifications"))
  }
}

function* onMarkNotificationRead({ payload: notificationId }) {
  try {
    yield call(markNotificationAsRead, notificationId)
  } catch (error) {
    console.error("Failed to mark notification as read:", error)
  }
}

function* onMarkAllNotificationsRead() {
  try {
    yield call(markAllNotificationsAsRead)
  } catch (error) {
    console.error("Failed to mark all notifications as read:", error)
  }
}

function* realtimeChatSaga() {
  yield takeEvery(FETCH_MESSAGES, onFetchMessages)
  yield takeEvery(SEND_MESSAGE, onSendMessage)
  yield takeEvery(FETCH_NOTIFICATIONS, onFetchNotifications)
  yield takeEvery(MARK_NOTIFICATION_READ, onMarkNotificationRead)
  yield takeEvery(MARK_ALL_NOTIFICATIONS_READ, onMarkAllNotificationsRead)
}

export default realtimeChatSaga
